// Routes for the dev server
import { Outlet, useLocation } from 'react-router-dom'

import DevHeader from '../dev-components/DevHeader'

export default function Root() {
  const location = useLocation()
  const routes = [
    { path: '/', label: 'Choose component' },
    { path: '/accordion', label: 'Accordion' },
    { path: '/alert', label: 'Alert' },
    { path: '/backlink', label: 'BackLink' },
    { path: '/breadcrumbs', label: 'Breadcrumbs' },
    { path: '/button', label: 'Button' },
    { path: '/card', label: 'Card' },
    { path: '/checkbox', label: 'Checkbox' },
    { path: '/combobox', label: 'Combobox' },
    { path: '/consent', label: 'Consent' },
    { path: '/datepicker', label: 'Datepicker' },
    { path: '/fileupload', label: 'FileUpload' },
    { path: '/footer', label: 'Footer' },
    { path: '/header', label: 'Header' },
    { path: '/header-service', label: 'HeaderService' },
    { path: '/header-full', label: 'Header full', hideHeader: true },
    { path: '/heading', label: 'Heading' },
    { path: '/icon', label: 'Icon' },
    { path: '/messagebox', label: 'Messagebox' },
    { path: '/modal', label: 'Modal' },
    { path: '/link', label: 'Link' },
    { path: '/linkcard', label: 'Linkcard' },
    { path: '/loader', label: 'Loader' },
    { path: '/progressbar', label: 'ProgressBar' },
    { path: '/radiobutton', label: 'RadioButton' },
    { path: '/searchinput', label: 'SearchInput' },
    { path: '/select', label: 'Select' },
    { path: '/stepper', label: 'Stepper' },
    { path: '/switch', label: 'Switch' },
    { path: '/table', label: 'Table' },
    { path: '/tabs', label: 'Tabs' },
    { path: '/tag', label: 'Tag' },
    { path: '/template-form', label: 'Template: Form' },
    { path: '/textarea', label: 'Textarea' },
    { path: '/textinput', label: 'Textinput' },
  ]

  const currentRoute = routes.find((route) => route.path === location.pathname)
  const hideHeader = currentRoute?.hideHeader

  return (
    <>
      <div id="app" className="page-container">
        {!hideHeader && <DevHeader routes={routes} />}
        <Outlet />
      </div>
    </>
  )
}
